import { STRICT_WS, STRICT_WS_ERROR, STRICT_WS_SUCCESS} from './actionTypes';

export const strictWorkstations = ( ws, token, history) => {
    return {
        type: STRICT_WS,
        payload: { ws, token, history }
    }
}

export const strictWorkstationsSuccess = (message) => {
    return {
        type: STRICT_WS_SUCCESS,
        payload: {message}
    }
}

export const strictWorkstationsError = (ws) => {
    return {
        type: STRICT_WS_ERROR,
        payload: ws
    }
}
